import { computed, useRoute, useStore } from '@nuxtjs/composition-api'

export default function useGoAnchor() {
  const store = useStore()
  const route = useRoute()

  const isMobile = computed(() => store.state.isMobile)

  function specificRowHeight(index) {
    const pcHeadRowHeight = 35
    const pcBodyRowHeight = 140
    const mobileBodyRowHeight = 422

    return !isMobile.value
      ? pcBodyRowHeight * (index - 1) + pcHeadRowHeight
      : mobileBodyRowHeight * (index - 1)
  }
  function goTo(selector, type) {
    let num = $('header').height() + parseInt($('main').css('padding-top'))

    if (route.value.path.startsWith('/payment')) {
      switch (type) {
        case 'JCB':
          num = num - specificRowHeight(1)
          break
        case 'ETH':
        case 'XRP':
        case 'USDT-ERC20':
        case 'USDT-OMNI':
        case 'MOON':
        case 'BTC':
          num = num - specificRowHeight(2)
          break
        case 'Payz':
          num = num - specificRowHeight(3)
          break
        case 'STICPAY':
          num = num - specificRowHeight(4)
          break
        default:
          num = num - specificRowHeight(1)
          break
      }
    }

    window.scrollTo({
      top: $(selector).offset().top - num,
      behavior: 'smooth'
    })
  }
  function goTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  return {
    isMobile,

    specificRowHeight,
    goTo,
    goTop
  }
}
